var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M16 26.8C16 25.1198 16 24.2798 16.327 23.638C16.6146 23.0735 17.0735 22.6146 17.638 22.327C18.2798 22 19.1198 22 20.8 22H27.2C28.8802 22 29.7202 22 30.362 22.327C30.9265 22.6146 31.3854 23.0735 31.673 23.638C32 24.2798 32 25.1198 32 26.8V28.2C32 29.8802 32 30.7202 31.673 31.362C31.3854 31.9265 30.9265 32.3854 30.362 32.673C29.7202 33 28.8802 33 27.2 33H20.8C19.1198 33 18.2798 33 17.638 32.673C17.0735 32.3854 16.6146 31.9265 16.327 31.362C16 30.7202 16 29.8802 16 28.2V26.8Z",
    fill: "#0C5D53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22V20C29 17.2386 26.7614 15 24 15C21.2386 15 19 17.2386 19 20V22M24 26.5V28.5M20.8 33H27.2C28.8802 33 29.7202 33 30.362 32.673C30.9265 32.3854 31.3854 31.9265 31.673 31.362C32 30.7202 32 29.8802 32 28.2V26.8C32 25.1198 32 24.2798 31.673 23.638C31.3854 23.0735 30.9265 22.6146 30.362 22.327C29.7202 22 28.8802 22 27.2 22H20.8C19.1198 22 18.2798 22 17.638 22.327C17.0735 22.6146 16.6146 23.0735 16.327 23.638C16 24.2798 16 25.1198 16 26.8V28.2C16 29.8802 16 30.7202 16.327 31.362C16.6146 31.9265 17.0735 32.3854 17.638 32.673C18.2798 33 19.1198 33 20.8 33Z",
    stroke: "#0C5D53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bf7412b30ad70e22b495826545c84844.svg";
export { ForwardRef as ReactComponent };